import React, { useMemo } from 'react'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  offer: App.CarHireOffer;
}

function CarHireOfferTileLocation(props: Props) {
  const { offer } = props

  const hasDifferentLocations = useMemo(() => offer.pickUp.id !== offer.dropOff.id, [offer])

  return (
    <BodyText variant="small" colour="neutral-two">
      {hasDifferentLocations && <>
        Pick up{' '}<BodyText variant="small" as="span" weight="bold">{offer.pickUp.name}</BodyText>,{' '}
        Drop off{' '}<BodyText variant="small" as="span" weight="bold">{offer.dropOff.name}</BodyText>
      </>}
      {!hasDifferentLocations && <>
        Pick up and drop off at{' '}<BodyText variant="small" as="span" weight="bold">{offer.pickUp.name}</BodyText>
      </>}
    </BodyText>
  )
}

export default CarHireOfferTileLocation
